import { render, staticRenderFns } from "./myCreativity.vue?vue&type=template&id=64cd169c&scoped=true"
import script from "./myCreativity.vue?vue&type=script&lang=js"
export * from "./myCreativity.vue?vue&type=script&lang=js"
import style0 from "./myCreativity.vue?vue&type=style&index=0&id=64cd169c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd169c",
  null
  
)

export default component.exports